import { captureException } from '@sentry/react';
import type { Id } from 'types';

type SubmitDirectContactPauseArgs = {
  invoiceIds: Array<string>;
  debtorId: Id;
  reason_id: string;
  end_at?: string;
  comment?: string;
  createDebtorComment: (
    variables: { id: Id; comment: string },
    options?: { onSuccess?: () => void },
  ) => void;
  batchAction: (
    actionType: string,
    invoiceIds: Array<string>,
    values: Record<string, unknown>,
  ) => void;
};

export function submitDirectContactPause({
  invoiceIds,
  debtorId,
  reason_id,
  end_at,
  comment,
  createDebtorComment,
  batchAction,
}: SubmitDirectContactPauseArgs) {
  if (invoiceIds.length === 0) {
    captureException(new Error('submitDirectContactPause called with no invoices'));
    return;
  }

  const pause = () => batchAction('pause', invoiceIds, { reason_id, end_at });

  if (!comment) {
    pause();
    return;
  }

  // Save the note first; only pause once it is persisted so a failed note never
  // leaves invoices paused without the record the user intended to keep.
  createDebtorComment({ id: debtorId, comment }, { onSuccess: pause });
}
